<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <video-uploader :allowType="mediaConfig.videoAllowType"
                            :tip="mediaConfig.videoTip"
                            :maxSize="mediaConfig.videoMaxSize"
                            :videoUrl="config[field.key]"
                            @uploaded="handleUpload"></video-uploader>
            <p v-html="field.memo"></p>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

  import VideoUploader from '@/components/VideoUploader.vue';
  export default {
    name: 'tms-type-video',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      source: {
        type: String,
      },
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // }
    },
    computed: {
      // 右侧组件数据初始化
      config() {
        console.log(this.source, this.field, this.$store.state.tms.config)
        if (this.source === 'tmsPageConfig') {
        return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
        return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    data() {
      return {
        mediaConfig: {
          videoTip: '格式要求：MP4，大小不超过500M',
          videoAllowType: ['mp4'],
          videoMaxSize: 500
        }
      }
    },

    components: {
      VideoUploader
    },

    mounted() {

    },

    methods: {
      handleUpload(src, index) {
        this.$set(this.config, this.field.key, src);
      },
    }
  }

</script>
